import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 密码修改  获取验证码
interface PhoneCodeJson {
  token: string;
  old_password: string;
  new_password: string;
  re_new_password: string;
}
export const changeAdminPassword = (json: PhoneCodeJson): any =>
  http.httpPost({
    url: httpApi.account.changeAdminPassword,
    json,
  });

// 获取操作日志
interface GetLogListJson {
  token: string;
  type: string;
  username: string;
  begin_time: string;
  end_time: string;
  page: number;
  size: number;
}

export const getLogList = (json: GetLogListJson): any =>
  http.httpGet({
    url: httpApi.account.getLogList,
    json,
  });

// 获取操作日志
export const getLogTypeList = (): any =>
  http.httpPost({
    url: httpApi.account.getLogTypeList
  });
